import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

@Pipe({
    name: 'strictTitleCase',
    standalone: true
})
export class StrictTitleCasePipe extends TitleCasePipe implements PipeTransform {
    constructor() {
        super();
    }

    transform(value: string): string;
    transform(value: null | undefined): null;
    transform(value: string | null | undefined): string | null {
        if (value === null || value === undefined || typeof value === 'number') {
            return '';
        }
        value = value
            .replace(/[_-]+/g, ' ') // Replace underscores and hyphens with spaces
            .replace(/\s+/g, ' ') // Normalize multiple spaces to a single space
            .trim(); // Remove leading and trailing spaces
        return super.transform(value);
    }
}
